

























































































































































































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import BrandAndModel from '@/views/reports/forms/flow/views/conditions/brand-and-model.vue';
import BrowserAndVersion from '@/views/reports/forms/flow/views/conditions/browser-and-version.vue';
import OsAndVersion from '@/views/reports/forms/flow/views/conditions/os-and-version.vue';
import Dictionary from '@/views/reports/forms/flow/views/conditions/dictionary.vue';
import ConnectionType from '@/views/reports/forms/flow/views/conditions/connection-type.vue';
import Custom from '@/views/reports/forms/flow/views/conditions/custom.vue';
import CustomToken from '@/views/reports/forms/flow/views/conditions/custom-token.vue';
import Crawler from '@/views/reports/forms/flow/views/conditions/crawler.vue';
import QueryHeader from '@/views/reports/forms/flow/views/conditions/query-header.vue';
import DayOfWeek from '@/views/reports/forms/flow/views/conditions/day-of-week.vue';
import TimeOfDay from '@/views/reports/forms/flow/views/conditions/time-of-day.vue';
import Timezone from '@/views/reports/forms/flow/views/conditions/timezone.vue';
import DeviceType from '@/views/reports/forms/flow/views/conditions/device-type.vue';
import Ip from '@/views/reports/forms/flow/views/conditions/ip.vue';
import Referrer from '@/views/reports/forms/flow/views/conditions/referrer.vue';
import ReferrerDomain from '@/views/reports/forms/flow/views/conditions/referrer-domain.vue';
import UserAgent from '@/views/reports/forms/flow/views/conditions/user-agent.vue';
import Webview from '@/views/reports/forms/flow/views/conditions/webview.vue';
import Proxy from '@/views/reports/forms/flow/views/conditions/proxy.vue';
import VisitCountryMatch from '@/views/reports/forms/flow/views/conditions/visit-country-match.vue';

import { validationMixin, Validation } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { ValidationProperties, ValidationGroups } from 'vue/types/vue';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import IpBlacklisted from '@/views/reports/forms/flow/views/conditions/ip-blacklisted.vue';
import IpDataCenter from '@/views/reports/forms/flow/views/conditions/ip-data-center.vue';
import IpWithFrequentEvents from '@/views/reports/forms/flow/views/conditions/ip-with-frequent-events.vue';
import IpWithFrequentCampaignEvents from '@/views/reports/forms/flow/views/conditions/ip-with-frequent-campaign-events.vue';
import ExternalId from '@/views/reports/forms/flow/views/conditions/external-id.vue';

const validations = {
  name: {
    required,
  },
};

@Component({
  components: {
    ExternalId,
    BrandAndModel,
    BrowserAndVersion,
    OsAndVersion,
    Dictionary,
    ConnectionType,
    Custom,
    CustomToken,
    QueryHeader,
    DayOfWeek,
    DeviceType,
    Ip,
    Referrer,
    UserAgent,
    TimeOfDay,
    Timezone,
    Webview,
    ReferrerDomain,
    Crawler,
    Proxy,
    IpBlacklisted,
    IpDataCenter,
    IpWithFrequentEvents,
    IpWithFrequentCampaignEvents,
    VisitCountryMatch,
  },
  validations: validations
})
export default class RuleSettings extends mixins<PlanLimitsMixin>(validationMixin,PlanLimitsMixin) {
  @Prop() target: any;
  @Prop() rule: any;
  @Prop() errorsName: any[] = [];
  @Prop() active_name: any;

  @Prop({
    default: 'and'
  }) relation: string;

  @Watch('active_name', {
    immediate: true
  })
  setActiveName(v: string) {
    this.name = v;
  }

  @Watch('name')
  onNameChanged(value: string) {
    this.$emit('update:active_name', value);
  }

  @Watch('relation', {
    immediate: true
  })
  onRelationChanged(value: string) {
    this.pRelation = value;
  }

  @Watch('pRelation')
  onPRelationChanged(value: string) {
    this.$emit('update:relation', value);
  }

  pRelation: string = 'and';

  resetValidation() {
    this.$v.$reset();
  }

  // @ts-ignore
  $v:  ValidationProperties<typeof validations> & ValidationGroups & Validation;

  @Watch('$v.$invalid', { immediate: true })
  onVInvalidChanged(value: boolean) {
    this.$emit('invalid', value);
  }

  name: string = '';
  conditions: any[] = [
    //do not change order
    { name: this.t('Brand and model'), condition: 'brand' },
    { name: this.t('Browser and version'), condition: 'browser' },
    { name: this.t('Connection type'), condition: 'connectType' },
    { name: this.t('Country'), condition: 'country' },
    { name: this.t('State / region'), condition: 'state' },
    { name: this.t('City'), condition: 'city' },
    { name: this.t('Custom token'), condition: 'customToken' },
    { name: this.t('Query header'), condition: 'queryHeader' },
    { name: this.t('Custom 1'), condition: 'custom1' },
    { name: this.t('Custom 2'), condition: 'custom2' },
    { name: this.t('Custom 3'), condition: 'custom3' },
    { name: this.t('Custom 4'), condition: 'custom4' },
    { name: this.t('Custom 5'), condition: 'custom5' },
    { name: this.t('Custom 6'), condition: 'custom6' },
    { name: this.t('Custom 7'), condition: 'custom7' },
    { name: this.t('Custom 8'), condition: 'custom8' },
    { name: this.t('Custom 9'), condition: 'custom9' },
    { name: this.t('Custom 10'), condition: 'custom10' },
    { name: this.t('Day of week'), condition: 'dayOfWeek' },
    { name: this.t('Time of day'), condition: 'timeOfDay' },
    { name: this.t('Device type'), condition: 'deviceType' },
    { name: this.t('IP'), condition: 'ip' },
    { name: this.t('ISP'), condition: 'isp' },
    { name: this.t('Language'), condition: 'language' },
    { name: this.t('Mobile carrier'), condition: 'mobileCarrier' },
    { name: this.t('OS and version'), condition: 'os' },
    { name: this.t('Referrer'), condition: 'referrer' },
    { name: this.t('Referrer Domain'), condition: 'referrerDomain' },
    { name: this.t('User agent'), condition: 'userAgent' },
    { name: this.t('WebView'), condition: 'webViewMark' },
    { name: this.t('Crawler'), condition: 'crawler' },
    { name: this.t('Proxy'), condition: 'proxy' },
    { name: this.t('Suspicious Traffic (blacklisted IPs)'), condition: 'ipBlacklisted' },
    { name: this.t('Suspicious Traffic (data centres IPs)'), condition: 'ipDataCenter' },
    { name: this.t('Suspicious Traffic (Frequent Events)'), condition: 'ipWithFrequentEvents' },
    { name: this.t('Suspicious Traffic (Frequent Campaign Events)'), condition: 'ipWithFrequentCampaignEvents' },
    { name: this.t('Campaign and Visit Geo'), condition: 'visitCountryMatch' },
    { name: this.t('External ID'), condition: 'externalId' },
  ];

  get menuList() {
    return this.conditions
      .filter((item) => !item.selected)
      .map<Bemob.ListItem>((item) => ({
        key: item.condition,
        title: item.name,
        planLimits: this.conditionPlanLimits(item.condition),
        click: () => this.add(item)
      }));
  }

  get isTimezoneAvailable() {
    return this.is_selected('timeOfDay') || this.is_selected('dayOfWeek');
  }

  get isClientHintsNoticeVisible() {
    return Object.keys(this.rule.conditions).some((item)=>[ 'os', 'browser', 'deviceType','brand' ].includes(item))
  }

  get conditionNotSelected() {
    return this.conditions.filter(c => !c.selected);
  }

  @Watch('rule.conditions', {  immediate: true })
  changeConditions(value: any) {
    if(!value) {
      return;
    }

    const rules = Object.keys(value);
    this.conditions.forEach((item, index) => {
      const hasRule = rules.indexOf(item.condition) !== -1;
      this.add(index, hasRule);
    });
  }

  add(item: any, value: boolean = true) {
    let index = typeof item === 'number'
      ? item
      : this.conditions.indexOf(item);

    if (index !== -1) {
      this.conditions[index].selected = value;
      this.$set(this.conditions, index, this.conditions[index]);
    }
  }

  remove(name: any) {
    let index = this.conditions.findIndex((e: any) => e.selected && e.condition === name);
    if (index !== -1) {
      this.conditions[index].selected = false;
      this.$set(this.conditions, index, this.conditions[index]);
    }

    if(!this.isTimezoneAvailable && this.rule.conditions.timezone) {
      this.$delete(this.rule.conditions, 'timezone');
    }

    this.$delete(this.rule.conditions, name);
  }

  is_selected(type: any) {
    return this.selected.indexOf(type) !== -1;
  }

  get selected() {
    return this.conditions
      .filter((e: any) => e.selected)
      .map((e: any) => e.condition);
  }

  deselect_all() {
    this.conditions.forEach((e: any) => {
      e.selected = false;
    });
    this.rule.conditions = {};
  }

  get rule_active() {
    return this.rule.status === 'active';
  }

  set rule_active(val: boolean) {
    this.rule.status = val
      ? 'active'
      : 'inactive';
  }
}
